// Template HTML de Nota de Entrega (formato oficial)
// Basado en el diseño proporcionado por RRHH y Ventas - igual al documento Word
// Estructura con divs separados para mejor edición

const notaCompraTemplateHtml = `<!DOCTYPE html>
<html lang="es">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>NOTA DE ENTREGA N° {{numero}}</title>
    <style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }
        
        body {
            font-family: Arial, sans-serif;
            font-size: 11pt;
            line-height: 1.3;
            color: #000;
            background: #fff;
            padding: 20px;
        }
        
        .document {
            max-width: 750px;
            margin: 0 auto;
            background: #fff;
            padding: 20px;
        }
        
        /* ==================== ENCABEZADO ==================== */
        .header-section {
            text-align: right;
            margin-bottom: 40px;
        }
        
        .header-row {
            margin: 2px 0;
        }
        
        .header-label {
            font-weight: bold;
        }
        
        /* ==================== TITULO ==================== */
        .title-section {
            text-align: center;
            margin-bottom: 30px;
        }
        
        .title-section h1 {
            font-size: 16pt;
            font-weight: bold;
            margin: 0;
            padding: 0;
        }
        
        /* ==================== ITEMS ENTREGADOS ==================== */
        .items-section {
            margin-bottom: 20px;
        }
        
        .items-title {
            font-weight: bold;
            font-size: 11pt;
            margin-bottom: 5px;
        }
        
        .items-title h1 {
            font-size: 11pt;
            font-weight: bold;
            margin: 0;
            padding: 0;
            display: inline;
        }
        
        /* Tabla de items */
        .items-table {
            width: 100%;
            border-collapse: collapse;
        }
        
        .items-table th,
        .items-table td {
            border: 1px solid #000;
            padding: 6px 4px;
            text-align: center;
            vertical-align: middle;
            font-size: 10pt;
        }
        
        .items-table th {
            background-color: #e0e0e0;
            font-weight: normal;
        }
        
        .items-table .col-cantidad { width: 12%; }
        .items-table .col-descripcion { width: 38%; }
        .items-table .col-factura { width: 12%; }
        .items-table .col-gid { width: 18%; }
        .items-table .col-empresa { width: 20%; }
        
        .items-table td.col-descripcion,
        .items-table td.col-empresa {
            text-align: left;
        }
        
        .items-table tr.empty-row {
            height: 28px;
        }
        
        /* ==================== TERMINOS ==================== */
        .terminos-section {
            margin-bottom: 15px;
            font-size: 10pt;
        }
        
        .terminos-label {
            font-weight: bold;
        }
        
        .terminos-text {
            display: inline;
        }
        
        /* ==================== OBSERVACIONES ==================== */
        .observaciones-section {
            margin-bottom: 30px;
        }
        
        .observaciones-title h1 {
            font-size: 11pt;
            font-weight: bold;
            margin: 0 0 8px 0;
        }
        
        .observaciones-line {
            border-bottom: 1px solid #000;
            height: 22px;
            margin-bottom: 3px;
        }
        
        /* ==================== FIRMAS ==================== */
        .firmas-section {
            margin-top: 50px;
        }
        
        .firmas-container {
            display: flex;
            justify-content: space-between;
            gap: 80px;
        }
        
        /* Firma Izquierda - Cliente */
        .firma-izquierda {
            flex: 1;
            display: flex;
            flex-direction: column;
        }
        
        .firma-izquierda .titulo-firma h1 {
            font-size: 11pt;
            font-weight: bold;
            margin: 0;
            line-height: 1.2;
        }
        
        .firma-izquierda .subtitulo-firma {
            font-size: 10pt;
            margin: 0;
            line-height: 1.2;
        }
        
        .firma-izquierda .spacer-firma {
            height: 40px;
        }
        
        .firma-izquierda .linea-firma {
            border-bottom: 1px solid #000;
            height: 30px;
            margin-bottom: 15px;
        }
        
        .firma-izquierda .campo-firma {
            font-size: 10pt;
            margin: 8px 0;
        }
        
        /* Input editable para Nombre/C.I. - se ve como línea para escribir */
        .firma-izquierda .input-firma,
        .firma-derecha .input-firma {
            border: none;
            border-bottom: 1px solid #999;
            background: transparent;
            font-family: Arial, sans-serif;
            font-size: 10pt;
            min-width: 160px;
            padding: 0 2px;
            outline: none;
        }
        
        .firma-izquierda .input-firma:focus,
        .firma-derecha .input-firma:focus {
            border-bottom: 1px solid #333;
            background: #f9f9f9;
        }
        
        /* Firma Derecha - Entregador */
        .firma-derecha {
            flex: 1;
            display: flex;
            flex-direction: column;
        }
        
        /* Entregado por - más pequeño (10pt) para alinearse con Recibido por */
        .firma-derecha .titulo-firma h1 {
            font-size: 10pt;
            font-weight: bold;
            margin: 0;
            line-height: 1.2;
        }
        
        .firma-derecha .subtitulo-firma {
            font-size: 10pt;
            margin: 0;
            line-height: 1.2;
            visibility: hidden;
        }
        
        .firma-derecha .spacer-firma {
            height: 40px;
        }
        
        .firma-derecha .linea-firma {
            border-bottom: 1px solid #000;
            height: 30px;
            margin-bottom: 15px;
        }
        
        .firma-derecha .campo-firma {
            font-size: 10pt;
            margin: 8px 0;
        }
        
        @media print {
            body { 
                padding: 0;
            }
            .document {
                padding: 10px;
            }
            .input-firma {
                border-bottom: 1px solid #999 !important;
                background: transparent !important;
            }
        }
    </style>
</head>
<body>
    <div class="document">
        
        <!-- ==================== ENCABEZADO ==================== -->
        <div class="header-section">
            <div class="header-row">
                <span class="header-label">Nro:</span>
                <span id="numero">{{numero}}</span>
            </div>
            <div class="header-row">
                <span class="header-label">Fecha:</span>
                <span id="fecha">{{fecha}}</span>
            </div>
        </div>
        
        <!-- ==================== TITULO ==================== -->
        <div class="title-section">
            <h1>NOTA DE ENTREGA</h1>
        </div>
        
        <!-- ==================== ITEMS ENTREGADOS ==================== -->
        <div class="items-section">
            <div class="items-title">
                <h1>Items Entregados:</h1>
            </div>
            
            <table class="items-table">
                <thead>
                    <tr>
                        <th class="col-cantidad">Cantidad</th>
                        <th class="col-descripcion">Descripción</th>
                        <th class="col-factura">Factura</th>
                        <th class="col-gid">GID</th>
                        <th class="col-empresa">Empresa</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Item principal -->
                    <tr id="item-principal">
                        <td class="col-cantidad" id="cantidad">{{cantidad}}</td>
                        <td class="col-descripcion" id="descripcion">{{descripcion}}</td>
                        <td class="col-factura" id="factura">{{factura}}</td>
                        <td class="col-gid" id="gid">{{gid}}</td>
                        <td class="col-empresa" id="empresa">{{empresa}}</td>
                    </tr>
                    <!-- 6 Filas vacías -->
                    <tr class="empty-row"><td class="col-cantidad">&nbsp;</td><td class="col-descripcion">&nbsp;</td><td class="col-factura">&nbsp;</td><td class="col-gid">&nbsp;</td><td class="col-empresa">&nbsp;</td></tr>
                    <tr class="empty-row"><td class="col-cantidad">&nbsp;</td><td class="col-descripcion">&nbsp;</td><td class="col-factura">&nbsp;</td><td class="col-gid">&nbsp;</td><td class="col-empresa">&nbsp;</td></tr>
                    <tr class="empty-row"><td class="col-cantidad">&nbsp;</td><td class="col-descripcion">&nbsp;</td><td class="col-factura">&nbsp;</td><td class="col-gid">&nbsp;</td><td class="col-empresa">&nbsp;</td></tr>
                    <tr class="empty-row"><td class="col-cantidad">&nbsp;</td><td class="col-descripcion">&nbsp;</td><td class="col-factura">&nbsp;</td><td class="col-gid">&nbsp;</td><td class="col-empresa">&nbsp;</td></tr>
                    <tr class="empty-row"><td class="col-cantidad">&nbsp;</td><td class="col-descripcion">&nbsp;</td><td class="col-factura">&nbsp;</td><td class="col-gid">&nbsp;</td><td class="col-empresa">&nbsp;</td></tr>
                    <tr class="empty-row"><td class="col-cantidad">&nbsp;</td><td class="col-descripcion">&nbsp;</td><td class="col-factura">&nbsp;</td><td class="col-gid">&nbsp;</td><td class="col-empresa">&nbsp;</td></tr>
                </tbody>
            </table>
        </div>
        
        <!-- ==================== TERMINOS ==================== -->
        <div class="terminos-section">
            <span class="terminos-label">Términos de la Entrega:</span>
            <span class="terminos-text">El receptor declara haber recibido los artículos descritos en condiciones óptimas de funcionamiento.</span>
        </div>
        
        <!-- ==================== OBSERVACIONES ==================== -->
        <div class="observaciones-section">
            <div class="observaciones-title">
                <h1>Observaciones:</h1>
            </div>
            <div class="observaciones-line" id="observaciones">{{observaciones}}</div>
            <div class="observaciones-line"></div>
        </div>
        
        <!-- ==================== FIRMAS ==================== -->
        <div class="firmas-section">
            <div class="firmas-container">
                
                <!-- Firma Izquierda - Cliente -->
                <div class="firma-izquierda">
                    <div class="titulo-firma">
                        <h1>Firma Conforme</h1>
                    </div>
                    <div class="subtitulo-firma">Recibido por (Cliente)</div>
                    <div class="spacer-firma"></div>
                    <div class="linea-firma"></div>
                    <div class="campo-firma">
                        Nombre: <input type="text" class="input-firma" id="receiver_name" value="{{receiver_name}}" placeholder="" />
                    </div>
                    <div class="campo-firma">
                        C.I: <input type="text" class="input-firma" id="receiver_id" value="{{receiver_id}}" placeholder="" />
                    </div>
                </div>
                
                <!-- Firma Derecha - Entregador -->
                <div class="firma-derecha">
                    <div class="titulo-firma">
                        <h1>Entregado por</h1>
                    </div>
                    <div class="subtitulo-firma">&nbsp;</div>
                    <div class="spacer-firma"></div>
                    <div class="linea-firma"></div>
                    <div class="campo-firma">
                        Nombre: <input type="text" class="input-firma" id="deliverer_name" value="{{deliverer_name}}" placeholder="" />
                    </div>
                    <div class="campo-firma">
                        C.I: <input type="text" class="input-firma" id="deliverer_id" value="{{deliverer_id}}" placeholder="" />
                    </div>
                </div>
                
            </div>
        </div>
        
    </div>
    
    <script>
        function renderNotaCompra(data) {
            console.log('Renderizando nota con datos:', data);
            
            // Campos de texto normales (spans, divs)
            const camposTexto = ['numero', 'fecha', 'cantidad', 'descripcion', 'factura', 
                           'gid', 'empresa', 'observaciones'];
            
            camposTexto.forEach(campo => {
                const el = document.getElementById(campo);
                if (el && data[campo] !== undefined && data[campo] !== null) {
                    el.textContent = data[campo];
                }
            });
            
            // Campos de input (firmas) - usar .value en lugar de .textContent
            const camposInput = ['receiver_name', 'receiver_id', 'deliverer_name', 'deliverer_id'];
            
            camposInput.forEach(campo => {
                const el = document.getElementById(campo);
                if (el && data[campo] !== undefined && data[campo] !== null) {
                    el.value = data[campo];
                }
            });
        }
        
        function descargarPDF() {
            window.print();
        }
    </script>
</body>
</html>`;

export default notaCompraTemplateHtml;
